import type { ComponentPropsWithRef } from 'react';
import { cn } from '@ifixit/ui/lib/utils';

export function FooterSettingsSection({ ref, className, ...props }: ComponentPropsWithRef<'div'>) {
   return (
      <div
         ref={ref}
         className={cn(
            'flex flex-col items-center justify-between gap-10 py-7 md:flex-row xl:gap-0 border-t border-b border-gray-800 my-2',
            className
         )}
         {...props}
      />
   );
}

export function FooterSettings({ ref, className, ...props }: ComponentPropsWithRef<'div'>) {
   return (
      <div
         ref={ref}
         className={cn('flex flex-row items-center gap-6 sm:gap-12', className)}
         {...props}
      />
   );
}
